import { accountActivitiesUrl } from '../urls';
import refresh from '../refresh';

export default async function getAccountActivities() {
  return refresh(async () => {
    const response = await fetch(accountActivitiesUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
